type DataSource = "d1" | "indexer" | "cache" | "seeded";

type DataFreshnessProps = {
	source: DataSource;
	updatedAt: Date;
};

const sourceColors: Record<DataSource, string> = {
	d1: "bg-pastel-vibrant-green",
	indexer: "bg-pastel-vibrant-green",
	cache: "bg-pastel-vibrant-blue",
	seeded: "bg-pastel-vibrant-orange",
};

function formatAge(date: Date): string {
	const seconds = Math.floor((Date.now() - date.getTime()) / 1000);
	if (seconds < 10) return "just now";
	if (seconds < 60) return `${String(seconds)}s ago`;
	const minutes = Math.floor(seconds / 60);
	if (minutes < 60) return `${String(minutes)}m ago`;
	const hours = Math.floor(minutes / 60);
	return `${String(hours)}h ago`;
}

export function DataFreshness({ source, updatedAt }: DataFreshnessProps) {
	return (
		<div className="inline-flex items-center gap-1.5 text-xs text-pastel-gray">
			<span className={`h-1.5 w-1.5 rounded-full ${sourceColors[source]}`} />
			<span>{source}</span>
			<span>&middot;</span>
			<span>{formatAge(updatedAt)}</span>
		</div>
	);
}
